<template>
  <v-app style="background-color:#eaeaea" id="app">
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Oswald&display=swap');
  @import url('https://use.fontawesome.com/releases/v5.8.2/css/all.css');
  #app {
    margin-top: -10px;
    font-size: 14px;
  }

  #app h2 {
    font-size: 21px;
  }

  #app hr {
    margin: unset;
    border-color: unset;
  }
</style>

